import { useDataChange, useOnChangeLastValueGuard } from 'Simple/Data.js'

export default function useDataOnChange(props) {
  let change = useDataChange({
    context: 'automations',
    viewPath: props.viewPath,
  })

  return useOnChangeLastValueGuard(function onChange(next) {
    change(inext => {
      let index = inext.findIndex(item => item.name === next.name)
      if (index > -1) {
        inext[index] = { ...next }
      }
    })
  })
}
